import React, { useState } from "react";
import styles from "./UpscMath2027Details.module.css";

const UPSCMathsTestSeries = () => {
  const [activeTab, setActiveTab] = useState("syllabus");

  // Razorpay payment links
  const razorpayLinks = {
    fullCourse: "https://pages.razorpay.com/exademy-upsc-2027", // Replace with actual link
    ctaCourse: "https://pages.razorpay.com/exademy-upsc-2027" // Replace with actual link
  };

  // Paper I Syllabus Topics
  const paper1Topics = [
    { topic: "Linear Algebra", weeks: 3, chapters: ["Vector Spaces", "Linear Transformations", "Matrix Theory", "Eigenvalues & Eigenvectors"] },
    { topic: "Calculus", weeks: 4, chapters: ["Real Numbers", "Sequence & Series", "Limits & Continuity", "Differentiation", "Mean Value Theorems"] },
    { topic: "Analytic Geometry", weeks: 2, chapters: ["2D Geometry", "3D Geometry", "Conic Sections", "Polar Coordinates"] },
    { topic: "Differential Equations", weeks: 4, chapters: ["First Order ODE", "Second Order ODE", "Partial Differential Equations", "Applications"] },
    { topic: "Vector Analysis", weeks: 2, chapters: ["Vector Differentiation", "Vector Integration", "Green's Theorem", "Stokes' Theorem"] },
    { topic: "Dynamics & Statics", weeks: 3, chapters: ["Forces & Equilibrium", "Friction", "Center of Gravity", "Projectile Motion"] }
  ];

  // Paper II Syllabus Topics
  const paper2Topics = [
    { topic: "Abstract Algebra", weeks: 4, chapters: ["Groups", "Rings", "Fields", "Vector Spaces", "Homomorphisms"] },
    { topic: "Real Analysis", weeks: 4, chapters: ["Metric Spaces", "Continuity", "Differentiability", "Riemann Integration", "Sequence of Functions"] },
    { topic: "Complex Analysis", weeks: 3, chapters: ["Analytic Functions", "Cauchy's Theorem", "Residue Theorem", "Conformal Mappings"] },
    { topic: "Linear Programming", weeks: 2, chapters: ["Simplex Method", "Duality", "Transportation Problem", "Game Theory"] },
    { topic: "Numerical Analysis", weeks: 2, chapters: ["Interpolation", "Numerical Integration", "Numerical ODE", "Error Analysis"] },
    { topic: "Probability & Statistics", weeks: 3, chapters: ["Probability Distributions", "Sampling", "Correlation", "Hypothesis Testing"] }
  ];

  // Monthly Teaching Plan
  const monthlyPlan = [
    { month: "August 2026", paper1: "Linear Algebra (Weeks 1-3)", paper2: "Abstract Algebra (Weeks 1-4)" },
    { month: "September 2026", paper1: "Calculus (Weeks 1-4)", paper2: "Real Analysis (Weeks 1-4)" },
    { month: "October 2026", paper1: "Analytic Geometry (Weeks 1-2)", paper2: "Complex Analysis (Weeks 1-3)" },
    { month: "November 2026", paper1: "Differential Equations (Weeks 1-4)", paper2: "Linear Programming (Weeks 1-2)" },
    { month: "December 2026", paper1: "Vector Analysis (Weeks 1-2)", paper2: "Numerical Analysis (Weeks 1-2)" },
    { month: "January 2027", paper1: "Dynamics & Statics (Weeks 1-3)", paper2: "Probability & Statistics (Weeks 1-3)" },
    { month: "February 2027", paper1: "Revision - Paper I (All Topics)", paper2: "Revision - Paper II (All Topics)" },
    { month: "March 2027", paper1: "Mock Tests - Paper I", paper2: "Mock Tests - Paper II" },
    { month: "April 2027", paper1: "Advanced Problem Solving", paper2: "Previous Year Paper Analysis" }
  ];

  // Test Series Schedule (May 2027 - August 2027)
  const testSchedule = [
    { week: 1, date: "2 May 2027", type: "Topic Test", topic: "Linear Algebra + Abstract Algebra" },
    { week: 2, date: "9 May 2027", type: "Topic Test", topic: "Calculus + Real Analysis" },
    { week: 3, date: "16 May 2027", type: "Topic Test", topic: "Analytic Geometry + Complex Analysis" },
    { week: 4, date: "23 May 2027", type: "Topic Test", topic: "Differential Equations + Linear Programming" },
    { week: 5, date: "30 May 2027", type: "Topic Test", topic: "Vector Analysis + Numerical Analysis" },
    { week: 6, date: "6 Jun 2027", type: "Topic Test", topic: "Dynamics & Statics + Probability" },
    { week: 7, date: "13 Jun 2027", type: "Mixed Test", topic: "Paper I - All Topics" },
    { week: 8, date: "20 Jun 2027", type: "Mixed Test", topic: "Paper II - All Topics" },
    { week: 9, date: "27 Jun 2027", type: "Full Syllabus", topic: "Full Mock Test - I" },
    { week: 10, date: "4 Jul 2027", type: "Full Syllabus", topic: "Full Mock Test - II" },
    { week: 11, date: "11 Jul 2027", type: "Full Syllabus", topic: "Full Mock Test - III" },
    { week: 12, date: "18 Jul 2027", type: "Full Syllabus", topic: "Full Mock Test - IV" },
    { week: 13, date: "25 Jul 2027", type: "Full Syllabus", topic: "Full Mock Test - V" },
    { week: 14, date: "1 Aug 2027", type: "Full Syllabus", topic: "Full Mock Test - VI" },
    { week: 15, date: "8 Aug 2027", type: "Full Syllabus", topic: "Full Mock Test - VII" },
    { week: 16, date: "15 Aug 2027", type: "Full Syllabus", topic: "Full Mock Test - VIII" },
    { week: 17, date: "22 Aug 2027", type: "Full Syllabus", topic: "Full Mock Test - IX" },
    { week: 18, date: "29 Aug 2027", type: "Full Syllabus", topic: "Full Mock Test - X" }
  ];

  // Handle Razorpay redirect
  const handleRazorpayRedirect = (link) => {
    window.open(link, "_blank");
  };

  return (
    <div className={styles.coursePage}>
      <div className={styles.container}>
        {/* Hero Section - Without Green Background - Centered */}
        <div className={styles.hero}>
          <div className={styles.heroContent}>
            <h1 className={styles.courseTitle}>
              UPSC Mathematics Optional <span className={styles.gradientText}>+ Test Series</span>
            </h1>
            <p className={styles.courseSubtitle}>
              Complete syllabus coverage in 9 months + 20 Full Syllabus & Topic Wise Tests
            </p>
            <div className={styles.courseMeta}>
              <div className={styles.metaItem}>
                <i className="fas fa-calendar-alt"></i>
                <span>Aug 2026 - Aug 2027</span>
              </div>
              <div className={styles.metaItem}>
                <i className="fas fa-clock"></i>
                <span>12 Months Access</span>
              </div>
              <div className={styles.metaItem}>
                <i className="fas fa-file-alt"></i>
                <span>20 Tests</span>
              </div>
              <div className={styles.metaItem}>
                <i className="fas fa-video"></i>
                <span>500+ Hours</span>
              </div>
            </div>
            <div className={styles.ctaButtons}>
              <button 
                className={styles.enrollBtn}
                onClick={() => handleRazorpayRedirect(razorpayLinks.fullCourse)}
              >
                <i className="fas fa-graduation-cap"></i>
                Enroll Now - ₹29,999
              </button>
            </div>
          </div>
        </div>

        {/* Tabs Navigation */}
        <div className={styles.tabsContainer}>
          <button 
            className={`${styles.tabBtn} ${activeTab === 'syllabus' ? styles.activeTab : ''}`}
            onClick={() => setActiveTab('syllabus')}
          >
            <i className="fas fa-book-open"></i>
            Syllabus
          </button>
          <button 
            className={`${styles.tabBtn} ${activeTab === 'teachingPlan' ? styles.activeTab : ''}`}
            onClick={() => setActiveTab('teachingPlan')}
          >
            <i className="fas fa-chalkboard-teacher"></i>
            Teaching Plan
          </button>
          <button 
            className={`${styles.tabBtn} ${activeTab === 'testSchedule' ? styles.activeTab : ''}`}
            onClick={() => setActiveTab('testSchedule')}
          >
            <i className="fas fa-calendar-check"></i>
            Test Schedule
          </button>
        </div>

        {/* Syllabus Tab Content - Only this tab shows the full content */}
        {activeTab === 'syllabus' && (
          <>
            <div className={styles.syllabusContent}>
              <h2 className={styles.sectionTitle}>Complete Syllabus Breakdown</h2>
              
              <div className={styles.syllabusGrid}>
                {/* Paper I */}
                <div className={styles.paperCard}>
                  <div className={styles.paperHeader}>
                    <h3>Paper I</h3>
                    <span className={styles.paperCode}>UPSC Maths Optional</span>
                  </div>
                  <div className={styles.topicList}>
                    {paper1Topics.map((topic, index) => (
                      <div key={index} className={styles.topicItem}>
                        <div className={styles.topicHeader}>
                          <h4>{topic.topic}</h4>
                          <span className={styles.weeksBadge}>{topic.weeks} weeks</span>
                        </div>
                        <ul className={styles.chapterList}>
                          {topic.chapters.map((chapter, idx) => (
                            <li key={idx}>
                              <i className="fas fa-check-circle"></i>
                              {chapter}
                            </li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Paper II */}
                <div className={styles.paperCard}>
                  <div className={styles.paperHeader}>
                    <h3>Paper II</h3>
                    <span className={styles.paperCode}>UPSC Maths Optional</span>
                  </div>
                  <div className={styles.topicList}>
                    {paper2Topics.map((topic, index) => (
                      <div key={index} className={styles.topicItem}>
                        <div className={styles.topicHeader}>
                          <h4>{topic.topic}</h4>
                          <span className={styles.weeksBadge}>{topic.weeks} weeks</span>
                        </div>
                        <ul className={styles.chapterList}>
                          {topic.chapters.map((chapter, idx) => (
                            <li key={idx}>
                              <i className="fas fa-check-circle"></i>
                              {chapter}
                            </li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Features Section - Only visible in Syllabus tab */}
            <div className={styles.featuresSection}>
              <h2 className={styles.sectionTitle}>Course Features</h2>
              <div className={styles.featuresGrid}>
                <div className={styles.featureCard}>
                  <i className="fas fa-chalkboard-teacher"></i>
                  <h3>Expert Faculty</h3>
                  <p>Learn from IIT/DU alumni with 10+ years experience</p>
                </div>
                <div className={styles.featureCard}>
                  <i className="fas fa-file-pdf"></i>
                  <h3>Study Material</h3>
                  <p>8 E-Books covering complete syllabus</p>
                </div>
                <div className={styles.featureCard}>
                  <i className="fas fa-clock"></i>
                  <h3>Doubt Sessions</h3>
                  <p>Weekly live doubt clearing sessions</p>
                </div>
                <div className={styles.featureCard}>
                  <i className="fas fa-chart-line"></i>
                  <h3>Performance Analysis</h3>
                  <p>Detailed feedback on every test</p>
                </div>
                <div className={styles.featureCard}>
                  <i className="fas fa-mobile-alt"></i>
                  <h3>Mobile Access</h3>
                  <p>Watch lectures anytime, anywhere</p>
                </div>
                <div className={styles.featureCard}>
                  <i className="fas fa-users"></i>
                  <h3>Batch Size</h3>
                  <p>Limited seats for personalized attention</p>
                </div>
              </div>
            </div>

            {/* FAQ Section - Only visible in Syllabus tab */}
            <div className={styles.faqSection}>
              <h2 className={styles.sectionTitle}>Frequently Asked Questions</h2>
              <div className={styles.faqGrid}>
                <div className={styles.faqItem}>
                  <h4>When does the batch start?</h4>
                  <p>The batch starts in August 2026 and runs till August 2027. Teaching phase from August 2026 to May 2027, followed by test series from May 2027 to August 2027.</p>
                </div>
                <div className={styles.faqItem}>
                  <h4>How are tests conducted?</h4>
                  <p>Tests are conducted every Sunday. You'll get detailed feedback and performance analysis within 48 hours.</p>
                </div>
                <div className={styles.faqItem}>
                  <h4>Is there any scholarship?</h4>
                  <p>Yes, merit-cum-means scholarship available. Up to 100% fee waiver for deserving candidates.</p>
                </div>
                <div className={styles.faqItem}>
                  <h4>Can I switch to this batch from another?</h4>
                  <p>Yes, you can transfer from any other batch. The syllabus coverage is comprehensive and you'll get all recorded lectures.</p>
                </div>
              </div>
            </div>

            {/* CTA Section - Only visible in Syllabus tab */}
            <div className={styles.ctaSection}>
              <h2>Ready to crack UPSC with Mathematics Optional?</h2>
              <p>Join India's most comprehensive mathematics program</p>
              <button 
                className={styles.ctaButton}
                onClick={() => handleRazorpayRedirect(razorpayLinks.ctaCourse)}
              >
                <i className="fas fa-graduation-cap"></i>
                Enroll Now - ₹29,999
              </button>
              <p className={styles.ctaNote}>Limited seats available • EMI options available</p>
            </div>
          </>
        )}

        {/* Teaching Plan Tab Content - Only syllabus content */}
        {activeTab === 'teachingPlan' && (
          <div className={styles.teachingPlanContent}>
            <h2 className={styles.sectionTitle}>9 Months Detailed Teaching Plan</h2>
            <p className={styles.planSubtitle}>August 2026 → May 2027</p>

            <div className={styles.timeline}>
              {monthlyPlan.map((month, index) => (
                <div key={index} className={styles.timelineItem}>
                  <div className={styles.timelineMonth}>
                    <span>{month.month}</span>
                  </div>
                  <div className={styles.timelineContent}>
                    <div className={styles.paperProgress}>
                      <div className={styles.paperProgressItem}>
                        <span className={styles.paperLabel}>Paper I:</span>
                        <span className={styles.paperTopics}>{month.paper1}</span>
                      </div>
                      <div className={styles.paperProgressItem}>
                        <span className={styles.paperLabel}>Paper II:</span>
                        <span className={styles.paperTopics}>{month.paper2}</span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Test Schedule Tab Content - Only test schedule */}
        {activeTab === 'testSchedule' && (
          <div className={styles.testScheduleContent}>
            <h2 className={styles.sectionTitle}>Test Series Schedule</h2>
            <p className={styles.planSubtitle}>May 2027 → August 2027 • Every Sunday</p>

            <div className={styles.testStats}>
              <div className={styles.testStatCard}>
                <span className={styles.testStatNumber}>10</span>
                <span className={styles.testStatLabel}>Topic Tests</span>
              </div>
              <div className={styles.testStatCard}>
                <span className={styles.testStatNumber}>2</span>
                <span className={styles.testStatLabel}>Mixed Tests</span>
              </div>
              <div className={styles.testStatCard}>
                <span className={styles.testStatNumber}>10</span>
                <span className={styles.testStatLabel}>Full Syllabus</span>
              </div>
              <div className={styles.testStatCard}>
                <span className={styles.testStatNumber}>20</span>
                <span className={styles.testStatLabel}>Total Tests</span>
              </div>
            </div>

            <div className={styles.testTableWrapper}>
              <table className={styles.testTable}>
                <thead>
                  <tr>
                    <th>Week</th>
                    <th>Date</th>
                    <th>Test Type</th>
                    <th>Topics Covered</th>
                  </tr>
                </thead>
                <tbody>
                  {testSchedule.map((test) => (
                    <tr key={test.week} className={test.type.includes('Full') ? styles.fullTestRow : ''}>
                      <td>Week {test.week}</td>
                      <td>{test.date}</td>
                      <td>
                        <span className={`${styles.testTypeBadge} ${
                          test.type === 'Topic Test' ? styles.topicBadge : 
                          test.type === 'Mixed Test' ? styles.mixedBadge : 
                          styles.fullBadge
                        }`}>
                          {test.type}
                        </span>
                      </td>
                      <td>{test.topic}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default UPSCMathsTestSeries;